import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((message, type = 'info') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  }, []);

  const showError = useCallback((message) => showToast(message, 'error'), [showToast]);
  const showSuccess = useCallback((message) => showToast(message, 'success'), [showToast]);

  const bgColor = {
    info: 'bg-slate-800',
    error: 'bg-red-600',
    success: 'bg-blue-600',
  };

  return (
    <ToastContext.Provider value={{ showToast, showError, showSuccess }}>
      {children}
      {toast && (
        <div className={`fixed top-4 left-1/2 -translate-x-1/2 z-[9999] ${bgColor[toast.type]} text-white px-4 py-3 rounded-xl shadow-lg text-sm font-medium max-w-sm text-center animate-fade-in-fast`}>
          {toast.message}
        </div>
      )}
    </ToastContext.Provider>
  );
};
